import {
  skipToken,
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { candidateEndpoints } from '@/modules/candidates/constants';
import type { components } from '@/types/apiSchema';

import { candidateJobNoteQueryKeys } from './queryKeys';

type CandidateJobNoteResponse =
  components['schemas']['CandidateJobNoteResponse'];

/** Pass `null` to hold the read until the notes are actually needed. */
export const useCandidateJobNotesQuery = (
  candidateJobId: string | null,
  options?: Omit<
    UseQueryOptions<CandidateJobNoteResponse[] | undefined, Error>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    queryKey: candidateJobNoteQueryKeys.list(candidateJobId),
    queryFn: candidateJobId
      ? async () => {
          const { data } = await fetchClient.GET(
            candidateEndpoints.candidateJobNotes,
            {
              params: { path: { candidateJobId } },
            },
          );

          return data;
        }
      : skipToken,
    ...options,
  });
};
